import CampaignTngDisbursementTable from "./campaignTngDisbursementTable.container";

export default CampaignTngDisbursementTable;
